module.exports = __webpack_public_path__ + "assets/img/189762656217e2c152977838ba073fd4.png";